<div class="w-full box-shadow p-2 pb-3" *transloco="let t">
  <div class="w-full flex-col flex gap-3 px-6 pb-6 text-mainTextLight text-sm" [innerHTML]="text"></div>
</div>
